import { trackGACustomEvent, trackEvent } from '../common'
import { GA_TRACK_CATEGORY } from '../constants'
import { IGenerics } from '../interfaces/analyticsInterfaces'

const EVENT_LOGIN = 'login'
const EVENT_LOGOUT = 'logout'

export const Generics: IGenerics = {
  trackUserLogin: (isLogin: boolean) => {
    if (isLogin) {
      trackEvent({ name: EVENT_LOGIN })
    } else {
      trackGACustomEvent({
        category: GA_TRACK_CATEGORY.AUTHENTICATION,
        action: EVENT_LOGOUT,
      })
    }
  },
}
